import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('auth-providers', { routeName: 'frontdoorResourceRoute' })
export class AuthProvider extends Resource {
    id: string;
    name: string;
    type: string;
    data: any;
}


